import styled from "@emotion/styled";

export const HostContainer = styled.div`
  padding: 16px;
`;
